import { toast } from 'react-toastify';

const TOAST_CLASSES = {
  error: 'g-bg--error',
  success: 'g-bg--error--success',
};

function getClass(type) {
  return TOAST_CLASSES[type];
}

export function makeToast(type, message, ...rest) {
  const additionalClass = getClass(type);

  return toast[type](message, {
    className: `toast ${additionalClass}`,
    position: 'bottom-right',
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...rest,
  });
}



// WEBPACK FOOTER //
// ./src/utils/ui/makeToast.js